if (!customElements.get('variant-selects')) {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => selector !== this);
      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper?.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.style.visibility = 'visible';
    }

    getProductFormElements() {
      return Array.from(document.querySelectorAll(`product-form[data-section="${this.dataset.section}"]`));
    }

    getNativeForms() {
      return Array.from(document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`));
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '');
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = this.fieldsets.map((fieldset) => {
        const select = fieldset.querySelector('select');
        if (select) return select.value;
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : '';
      });
    }

    updateVariantText() {
      this.fieldsets.forEach((fieldset, index) => {
        const label = fieldset.querySelector('.form__label__value');
        if (label) {
          label.textContent = this.options[index];
        }
      });
    }

    updateMasterId() {
      const variantData = this.getVariantData();
      if (!variantData) return;

      this.currentVariant = variantData.find((variant) => {
        return variant.options.every((option, index) => this.options[index] === option);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false' || !this.other.length) return;

      const other = this.other[0];
      const fieldsets = Array.from(other.querySelectorAll('fieldset'));

      this.options.forEach((option, index) => {
        const fieldset = fieldsets[index];
        if (!fieldset) return;

        const select = fieldset.querySelector('select');
        if (select) {
          select.value = option;
          return;
        }

        const input = fieldset.querySelector(`input[value='${option}']`);
        if (input) {
          input.checked = true;
        }
      });

      other.updateOptions();
      other.updateMasterId();
      other.updateVariantText();
      other.setDisabled();
    }

    updateMedia() {
      if (!this.currentVariant?.featured_media || !this.productSlider) return;

      const thumbnails = this.productWrapper?.querySelector('.product-thumbnail-container');

      this.setActiveMedia(
        `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        this.productSlider,
        thumbnails
      );
    }

    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      if (!productSlider) return;

      const activeMedia = productSlider.querySelector(mediaId);
      if (!activeMedia) return;

      if (productSlider.flkty && this.hideVariants) {
        const initialSelected = productSlider.querySelector('.product-images__slide.is-initial-selected');
        if (initialSelected) {
          initialSelected.classList.remove('is-initial-selected');
        }

        productSlider.querySelectorAll('.product-images__slide-item--variant').forEach((el) => {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active', 'is-initial-selected');
        this.setImageSetMedia();

        if (thumbnails) {
          const activeThumb = thumbnails.querySelector(thumbId);
          const initialThumb = thumbnails.querySelector('.product-thumbnail.is-initial-selected');

          if (initialThumb) {
            initialThumb.classList.remove('is-initial-selected');
          }

          thumbnails.querySelectorAll('.product-images__slide-item--variant').forEach((el) => {
            el.classList.remove('is-active');
          });

          if (activeThumb) {
            activeThumb.classList.add('is-active', 'is-initial-selected');
          }
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.flkty.selectCell(mediaId);
        return;
      }

      if (productSlider.flkty) {
        productSlider.flkty.selectCell(mediaId);
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      this.getNativeForms().forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (input) {
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const submitButton = productForm.closest('product-form')?.querySelector('.single-add-to-cart-button');
        if (submitButton) {
          submitButton.setAttribute('data-variant-id', this.currentVariant.id);
        }
      });

      this.getProductFormElements().forEach((productFormEl) => {
        const submitButton = productFormEl.querySelector('.single-add-to-cart-button');
        if (submitButton) {
          submitButton.setAttribute('data-variant-id', this.currentVariant.id);
        }
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = this.productWrapper?.querySelector('.pickup-availability-wrapper') || document.querySelector('.pickup-availability-wrapper');
      if (!pickUpAvailability) return;

      if (this.currentVariant?.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const productForm = this.productWrapper?.querySelector('product-form') || this.closest('section')?.querySelector('product-form');
      if (productForm) {
        productForm.handleErrorMessage();
      }
    }

    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `price-${this.dataset.section}--mobile`,
        `price-${this.dataset.section}--sticky`,
        `product-image-${this.dataset.section}--sticky`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
        `quantity-${this.dataset.section}`
      ];
    }

    renderProductInfo() {
      const sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) {
              destination.innerHTML = source.innerHTML;
            }

            if (id.includes('price') && destination) {
              destination.classList.remove('visibility-hidden');
            }
          });

          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
        });
    }

    shouldUseNotifyMeState(productFormEl) {
      if (!productFormEl) return false;

      const isDiscontinued = productFormEl.dataset.isDiscontinued === 'true';

      return Boolean(
        this.currentVariant &&
        productFormEl.dataset.hasRealVariants === 'true' &&
        this.currentVariant.available === false &&
        !isDiscontinued
      );
    }

    setAddButtonState(productFormEl, disable = true, text = false) {
      const submitButton = productFormEl?.querySelector('.single-add-to-cart-button');
      const submitButtonText = submitButton?.querySelector('.single-add-to-cart-button--text');
      if (!submitButton || !submitButtonText) return;

      const productTemplate = productFormEl.getAttribute('template');
      const notifyMeState = this.shouldUseNotifyMeState(productFormEl);

      if (disable && notifyMeState) {
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('loading', 'sold-out');
        submitButton.classList.add('notify-me');
        submitButton.type = 'button';
        submitButton.setAttribute('data-notify-active', 'true');
        submitButtonText.textContent = submitButton.dataset.notifyLabel || 'SOLD OUT - NOTIFY ME';
        return;
      }

      if (disable) {
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.classList.remove('loading', 'notify-me');
        submitButton.classList.add('sold-out');
        submitButton.type = 'submit';
        submitButton.setAttribute('data-notify-active', 'false');
        if (text) {
          submitButtonText.textContent = text;
        }
        return;
      }

      submitButton.removeAttribute('disabled');
      submitButton.classList.remove('loading', 'sold-out', 'notify-me');
      submitButton.type = 'submit';
      submitButton.setAttribute('data-notify-active', 'false');
      submitButtonText.textContent = productTemplate?.includes('pre-order') ? window.theme.variantStrings.preOrder : window.theme.variantStrings.addToCart;
    }

    toggleAddButton(disable = true, text = false) {
      this.getProductFormElements().forEach((productFormEl) => {
        this.setAddButtonState(productFormEl, disable, text);
      });
    }

    setUnavailable() {
      this.getProductFormElements().forEach((productFormEl) => {
        const submitButton = productFormEl.querySelector('.single-add-to-cart-button');
        const submitButtonText = submitButton?.querySelector('.single-add-to-cart-button--text');
        if (!submitButton || !submitButtonText) return;

        submitButton.setAttribute('disabled', 'disabled');
        submitButton.classList.remove('notify-me');
        submitButton.classList.add('sold-out');
        submitButton.setAttribute('data-notify-active', 'false');
        submitButton.type = 'submit';
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
      });

      const price = document.getElementById(`price-${this.dataset.section}`);
      const priceMobile = document.getElementById(`price-${this.dataset.section}--mobile`);
      const priceSticky = document.getElementById(`price-${this.dataset.section}--sticky`);

      if (price) price.classList.add('visibility-hidden');
      if (priceMobile) priceMobile.classList.add('visibility-hidden');
      if (priceSticky) priceSticky.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature !== 'true') return;

      const variantData = this.getVariantData();
      if (!variantData) return;

      const selectedOptions = this.options.map((value, index) => ({
        value,
        index: `option${index + 1}`
      }));

      const availableOptions = this.createAvailableOptionsTree(variantData, selectedOptions);

      this.fieldsets.forEach((fieldset, index) => {
        const optionKey = `option${index + 1}`;
        const fieldsetOptions = availableOptions[optionKey];
        if (!fieldsetOptions) return;

        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option').forEach((option) => {
            const entry = fieldsetOptions.find((item) => item.value === option.value);
            option.disabled = entry ? entry.isUnavailable : true;
          });
          return;
        }

        fieldset.querySelectorAll('input').forEach((input) => {
          const entry = fieldsetOptions.find((item) => item.value === input.value);
          input.classList.toggle('is-disabled', entry ? entry.isUnavailable : true);
        });
      });

      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      const dataSetEl = this.productSlider.querySelector('[data-set-name]');
      const imageSetInput = dataSetEl ? this.querySelector(`.product-form__input[data-handle="${dataSetEl.dataset.setName}"]`) : null;
      if (!dataSetEl || !imageSetInput) return;

      this.imageSetName = dataSetEl.dataset.setName;
      this.imageSetIndex = imageSetInput.dataset.index;
      this.dataset.imageSetIndex = this.imageSetIndex;
      this.setImageSetMedia();
    }

    setImageSetMedia() {
      if (!this.imageSetIndex || !this.currentVariant || !this.productWrapper) return;

      const setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      const group = `${this.imageSetName}_${setValue}`;
      const selectedSetImages = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`);
      const selectedSetThumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (!this.hideVariants) return;

      this.productWrapper.querySelectorAll('.product-images__slide').forEach((slide) => {
        if (slide.dataset.group && slide.dataset.group !== group) {
          slide.classList.remove('is-active');
        }
      });

      selectedSetImages.forEach((slide) => {
        slide.classList.toggle('is-active', slide.dataset.group === group);
      });

      this.productWrapper.querySelectorAll('.product-thumbnail').forEach((thumb) => {
        if (thumb.dataset.group && thumb.dataset.group !== group) {
          thumb.classList.remove('is-active');
        }
      });

      selectedSetThumbs.forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.group === group);
      });
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      const optionKeys = ['option1', 'option2', 'option3'];
      const tree = { option1: [], option2: [], option3: [] };

      optionKeys.forEach((key) => {
        const values = [...new Set(variant_data.map((variant) => variant[key]).filter((value) => value !== null))];
        tree[key] = values.map((value) => ({ value, isUnavailable: true }));
      });

      optionKeys.forEach((key) => {
        tree[key].forEach((entry) => {
          const exists = variant_data.some((variant) => {
            if (!variant.available) return false;
            if (variant[key] !== entry.value) return false;
            if (key === 'option1') return true;

            return selected_options.every(({ value, index }) => {
              if (index === key) return true;
              return variant[index] === value;
            });
          });

          entry.isUnavailable = !exists;
        });
      });

      return tree;
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }

  customElements.define('variant-selects', VariantSelects);

  class VariantRadios extends VariantSelects {
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.fieldsets = fieldsets;
      this.options = fieldsets.map((fieldset) => {
        const checked = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
        return checked ? checked.value : '';
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.setupProductGallery);
    }

    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container?.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');
      this.setOptions();
      this.init();
    }

    setOptions() {
      this.hide_variants = this.dataset.hideVariants === 'true';
      this.thumbnails = this.thumbnail_container ? this.thumbnail_container.querySelectorAll('.product-thumbnail') : [];
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: false,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }

    init() {
      this.flkty = new Flickity(this, this.options);
      this.selectedIndex = this.flkty.selectedIndex;
      this.setupEvents();
      this.setupProductGallery();
    }

    reInit() {
      this.flkty.destroy();
      this.setOptions();
      this.flkty = new Flickity(this, this.options);
      this.setupEvents();
      this.selectedIndex = this.flkty.selectedIndex;
    }

    setupEvents() {
      const _this = this;

      if (this.prev_button) {
        const prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();

        prev.addEventListener('click', () => {
          this.flkty.previous();
        });

        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }

      if (this.next_button) {
        const next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();

        next.addEventListener('click', () => {
          this.flkty.next();
        });

        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }

      this.video_containers.forEach((container) => {
        const button = container.querySelector('button');
        if (button) {
          button.addEventListener('click', () => {
            container.setAttribute('hidden', '');
          });
        }
      });

      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });

      this.flkty.on('change', (index) => {
        if (!this.flkty.cells.length) return;

        const previousCell = this.flkty.cells[_this.selectedIndex];
        const previousSlide = previousCell ? previousCell.element : null;
        const previousMedia = previousSlide?.querySelector('.product-single__media');
        const activeThumbs = Array.from(this.thumbnails).filter((element) => element.classList.contains('is-active'));
        const activeThumb = activeThumbs[index] || activeThumbs[0];

        Array.from(this.thumbnails).forEach((item) => {
          item.classList.remove('is-initial-selected');
        });

        if (activeThumb) {
          activeThumb.classList.add('is-initial-selected');

          requestAnimationFrame(() => {
            if (activeThumb.offsetParent === null) return;

            const windowHalfHeight = activeThumb.offsetParent.clientHeight / 2;
            const windowHalfWidth = activeThumb.offsetParent.clientWidth / 2;

            activeThumb.parentElement.scrollTo({
              left: activeThumb.offsetLeft - windowHalfWidth + activeThumb.clientWidth / 2,
              top: activeThumb.offsetTop - windowHalfHeight + activeThumb.clientHeight / 2,
              behavior: 'smooth'
            });
          });
        }

        if (!previousMedia) return;

        if (previousMedia.classList.contains('product-single__media-external-video')) {
          if (previousMedia.dataset.provider === 'youtube') {
            previousMedia.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: 'command',
              func: 'pauseVideo',
              args: ''
            }), '*');
          } else if (previousMedia.dataset.provider === 'vimeo') {
            previousMedia.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: 'pause'
            }), '*');
          }

          const playButton = previousMedia.querySelector('.product-single__media-external-video--play');
          if (playButton) {
            playButton.removeAttribute('hidden');
          }
        } else if (previousMedia.classList.contains('product-single__media-native-video')) {
          previousMedia.querySelector('video').pause();
        }
      });

      setTimeout(() => {
        Array.from(this.thumbnails)
          .filter((thumbnail) => thumbnail.clientWidth > 0)
          .forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
              this.thumbnailClick(thumbnail, index);
            });
          });
      });
    }

    thumbnailClick(thumbnail, index) {
      Array.from(this.thumbnails).forEach((item) => {
        item.classList.remove('is-initial-selected');
      });

      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }

    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }

    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }

    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) return;
      this.setEventListeners();
    }

    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        const index = Array.from(item.parentNode.parentNode.children).indexOf(item.parentNode);
        const activeLink = item.querySelector('.product-single__media-zoom');

        activeLink.dataset.index = index;

        return {
          src: activeLink.getAttribute('href'),
          msrc: activeLink.dataset.msrc,
          w: activeLink.dataset.w,
          h: activeLink.dataset.h
        };
      });
    }

    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelector('.pswp');
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected');
          const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          const rect = thumbnail.getBoundingClientRect();

          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };

      this.links.forEach((link) => {
        link.addEventListener('click', (event) => this.zoomClick(event, link));
      });
    }

    zoomClick(event, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);

      if (typeof PhotoSwipe !== 'undefined' && this.pswpElement) {
        const pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);

        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });

        pswp.init();
      }

      event.preventDefault();
    }
  }

  customElements.define('product-slider', ProductSlider);
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = this.querySelector('form');
      if (!this.form) return;

      const variantInput = this.form.querySelector('[name=id]');
      if (variantInput) {
        variantInput.disabled = false;
      }

      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) return;

      const submitButtons = Array.from(document.querySelectorAll(`product-form[data-section="${this.dataset.section}"] .single-add-to-cart-button`));

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        }
      };

      const formData = new FormData(this.form);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });

            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }

            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: Object.prototype.hasOwnProperty.call(response, 'items') ? response.items[0] : response
          });
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form'
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-secondary-area--item-count'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-secondary-area--item-amount'
        }
      ];
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container) return;

        const elementToReplace = container.querySelector(section.selector) || container;
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      });

      const productDrawer = document.getElementById('Product-Modal');

      if (productDrawer && productDrawer.contains(this)) {
        productDrawer.hide();
      }

      const cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        cartDrawer.open();
        cartDrawer.removeProductEvent();
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector(selector)?.innerHTML || '';
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
      this.setupObservers();
    }

    setupObservers() {
      const _this = this;
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const footer = document.getElementById('footer');
      if (!form || !footer) return;

      _this.formPassed = false;

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {
          if (entry.target === footer) {
            if (entry.intersectionRatio > 0) {
              _this.classList.remove('sticky--visible');
            } else if (entry.intersectionRatio === 0 && _this.formPassed) {
              _this.classList.add('sticky--visible');
            }
          }

          if (entry.target === form) {
            const boundingRect = form.getBoundingClientRect();

            if (entry.intersectionRatio === 0 && window.scrollY > boundingRect.top + boundingRect.height) {
              _this.formPassed = true;
              _this.classList.add('sticky--visible');
            } else if (entry.intersectionRatio === 1) {
              _this.formPassed = false;
              _this.classList.remove('sticky--visible');
            }
          }
        });
      }, { threshold: [0, 1] });

      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== 'undefined') {
  addIdToRecentlyViewed();
}

if (!window.__notifyMeBound) {
  window.__notifyMeBound = true;

  const KLAVIYO_COMPANY_ID = window.KLAVIYO_COMPANY_ID || 'YxPXm3';
  const KLAVIYO_REVISION = '2026-01-15';
  let activeNotifyButton = null;

  function isQuickViewButton(button) {
    return Boolean(button.closest('#Product-Modal, [id^="QuickShopModal-"], .modal--quick-shop, .quick-view'));
  }

  function ensureNotifyMeModal() {
    let modal = document.getElementById('NotifyMeApiModal');
    if (modal) return modal;

    if (!document.getElementById('NotifyMeApiStyles')) {
      const style = document.createElement('style');
      style.id = 'NotifyMeApiStyles';
      style.textContent = `.notify-me-api-open{overflow:hidden}.notify-me-api-modal[hidden]{display:none!important}.notify-me-api-modal{position:fixed;inset:0;z-index:999999;display:flex;align-items:center;justify-content:center;padding:16px}.notify-me-api-modal__overlay{position:absolute;inset:0;background:rgba(0,0,0,.42)}.notify-me-api-modal__dialog{position:relative;z-index:1;width:min(100%,392px);background:#fff;padding:28px 34px 22px;border-radius:0;box-shadow:0 18px 50px rgba(0,0,0,.16);color:#000;font-family:var(--font-body-family,"Albert Sans",sans-serif)}.notify-me-api-modal__close{position:absolute;top:12px;right:12px;display:flex;align-items:center;justify-content:center;width:28px;height:28px;padding:0;border:0;background:transparent;color:#000;font-family:var(--font-body-family,"Albert Sans",sans-serif);font-size:34px;line-height:1;cursor:pointer}.notify-me-api-modal__title{margin:0 34px 14px 0;padding:0 0 14px;border-bottom:1px solid #000;font-family:var(--font-body-family,"Albert Sans",sans-serif);font-size:clamp(22px,3vw,38px);font-weight:600;line-height:1.05;letter-spacing:-.02em;color:#000;max-width:260px}.notify-me-api-modal__copy{margin:0 0 18px;font-size:15px;line-height:1.45;max-width:270px;color:#000;font-family:var(--font-body-family,"Albert Sans",sans-serif)}.notify-me-api-modal__form{display:grid;gap:14px}.notify-me-api-modal__form input{width:100%;height:46px;padding:0 18px;border:1px solid #000;border-radius:8px;background:#fff;box-shadow:none;outline:none;appearance:none;color:#000;font:500 15px/1 var(--font-body-family,"Albert Sans",sans-serif)}.notify-me-api-modal__form input::placeholder{color:#666;opacity:1;font-family:var(--font-body-family,"Albert Sans",sans-serif)}.notify-me-api-modal__form button{width:100%;height:46px;border:0;border-radius:8px;background:#e7d66f;color:#000;font:600 18px/1 var(--font-body-family,"Albert Sans",sans-serif);cursor:pointer}.notify-me-api-modal__form button[disabled]{opacity:.7;cursor:default}.notify-me-api-modal__message{min-height:20px;margin-top:12px;font:500 14px/1.4 var(--font-body-family,"Albert Sans",sans-serif);color:#000}.notify-me-api-modal__message[data-state="error"]{color:#b42318}.notify-me-api-modal__message[data-state="success"]{color:#067647}@media (max-width:767px){.notify-me-api-modal{padding:16px}.notify-me-api-modal__dialog{width:min(100%,320px);padding:22px 24px 18px}.notify-me-api-modal__close{top:11px;right:11px;width:24px;height:24px;font-size:30px}.notify-me-api-modal__title{margin:0 28px 14px 0;padding-bottom:12px;font-size:clamp(20px,8vw,34px);max-width:220px}.notify-me-api-modal__copy{margin-bottom:18px;font-size:14px;max-width:none}.notify-me-api-modal__form input,.notify-me-api-modal__form button{height:44px}}`;
      document.head.appendChild(style);
    }

    document.body.insertAdjacentHTML('beforeend', `
  <div id="NotifyMeApiModal" class="notify-me-api-modal" hidden>
    <div class="notify-me-api-modal__overlay" data-notify-overlay></div>
    <div class="notify-me-api-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="NotifyMeApiTitle">
      <button type="button" class="notify-me-api-modal__close" data-notify-close aria-label="Close">&times;</button>

      <div id="NotifyMeApiTitle" class="notify-me-api-modal__title">
        Notify When<br>Back in Stock
      </div>

      <p id="NotifyMeApiCopy" class="notify-me-api-modal__copy">Receive an email for when this variant comes back in stock.</p>
      <form id="NotifyMeApiForm" class="notify-me-api-modal__form">
        <input id="NotifyMeApiEmail" type="email" required autocomplete="email" placeholder="Enter your email address">
        <button id="NotifyMeApiSubmit" type="submit">Notify Me!</button>
      </form>
      <div id="NotifyMeApiMessage" class="notify-me-api-modal__message" aria-live="polite"></div>
    </div>
  </div>
`);

    modal = document.getElementById('NotifyMeApiModal');

    modal.querySelector('[data-notify-overlay]').addEventListener('click', closeNotifyMeModal);
    modal.querySelector('[data-notify-close]').addEventListener('click', closeNotifyMeModal);

    modal.querySelector('#NotifyMeApiForm').addEventListener('submit', async function (event) {
      event.preventDefault();

      const messageEl = modal.querySelector('#NotifyMeApiMessage');
      const emailInput = modal.querySelector('#NotifyMeApiEmail');
      const submitButton = modal.querySelector('#NotifyMeApiSubmit');
      const email = emailInput.value.trim();
      const variantId = activeNotifyButton?.getAttribute('data-variant-id') || activeNotifyButton?.closest('product-form')?.querySelector('input[name="id"]')?.value;

      messageEl.textContent = '';
      messageEl.setAttribute('data-state', '');

      if (!KLAVIYO_COMPANY_ID) {
        messageEl.textContent = 'Klaviyo Site ID is missing.';
        messageEl.setAttribute('data-state', 'error');
        return;
      }

      if (!variantId) {
        messageEl.textContent = 'Could not determine the selected variant.';
        messageEl.setAttribute('data-state', 'error');
        return;
      }

      submitButton.disabled = true;

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`
              }
            }
          }
        }
      };

      try {
        const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(KLAVIYO_COMPANY_ID)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: KLAVIYO_REVISION
          },
          body: JSON.stringify(payload)
        });

        if (response.status === 202) {
          messageEl.textContent = "You're in. We'll email you when it's back.";
          messageEl.setAttribute('data-state', 'success');
          emailInput.value = '';

          setTimeout(() => {
            closeNotifyMeModal();
          }, 1200);

          return;
        }

        let data = null;

        try {
          data = await response.json();
        } catch (error) {}

        messageEl.textContent = data?.errors?.[0]?.detail || 'Could not save your back-in-stock request. Please try again.';
        messageEl.setAttribute('data-state', 'error');
      } catch (error) {
        messageEl.textContent = 'Network error. Please try again.';
        messageEl.setAttribute('data-state', 'error');
      } finally {
        submitButton.disabled = false;
      }
    });

    return modal;
  }

  function openNotifyMeModal(button) {
    activeNotifyButton = button;

    const modal = ensureNotifyMeModal();
    const messageEl = modal.querySelector('#NotifyMeApiMessage');
    const emailInput = modal.querySelector('#NotifyMeApiEmail');

    messageEl.textContent = '';
    messageEl.setAttribute('data-state', '');
    emailInput.value = '';

    modal.hidden = false;
    document.documentElement.classList.add('notify-me-api-open');
    document.body.classList.add('notify-me-api-open');

    setTimeout(() => {
      emailInput.focus();
    }, 0);
  }

  function closeNotifyMeModal() {
    const modal = document.getElementById('NotifyMeApiModal');
    if (!modal) return;

    modal.hidden = true;
    document.documentElement.classList.remove('notify-me-api-open');
    document.body.classList.remove('notify-me-api-open');
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeNotifyMeModal();
    }
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.single-add-to-cart-button');
    if (!button) return;
    if (button.getAttribute('data-notify-active') !== 'true') return;

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (isQuickViewButton(button)) {
      openNotifyMeModal(button);
      return;
    }

    const formEl = button.closest('product-form');
    const host = formEl?.querySelector('.nl-bis-trigger-host');
    const target = host?.querySelector('.klaviyo-bis-trigger, [role="button"], a, button');

    if (target) {
      target.click();
      return;
    }

    openNotifyMeModal(button);
  }, true);
}